import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Response } from '../model/response';
import { UserProfile } from '../model/affiliate.interfaces';
import { Store } from '@ngrx/store';
import { authApiActions } from 'src/app/store/actions/authentication.actions';
import { selectToken } from 'src/app/store/selectors/authentication.selectors';
import { PushService } from './push.service';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private httpClient = inject(HttpClient);
  private store = inject(Store);
  private pushService = inject(PushService);

  public login(payload: Partial<{ docType: number; docNumber: number; password: string }>): Observable<UserProfile> {
    const url = `${environment.apiUrl}login`;
    return this.httpClient.post<Response<UserProfile>>(url, payload).pipe(map(req => req.data));
  }

  public logout(): void {
    // El meta-reducer de logout borra el token: se captura antes para dar de baja el navegador.
    this.store.select(selectToken).pipe(first()).subscribe(token => {
      this.pushService.unregister(token);
      this.store.dispatch(authApiActions.logout());
    });
  }
}